export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5495.a2cdd474.jpg";